import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { withTheme } from 'styled-components';
import InterstitialContainer from '@gameday/components/Interstitial/containers/InterstitialDataContainer';
import { InterstitialModalContent } from '@gameday/components/Overlay/overlay.style';
import { ModalTypes } from '@gameday/components/AtBat/atbat.style';
import { getPromoInterstitialState } from '../store/interstitialSelector';
import Overlay from '../../Overlay/Overlay';

const PromoInterstitialOverlay = () => {
    const { promoInterstitial } = useSelector(getPromoInterstitialState);

    const [isInterstitialOpen, setIsInterstitialOpen] = useState(Boolean(promoInterstitial?.length));

    // Handles the closing of the interstitial modal
    const onInterstitialClose = useCallback(() => {
        setIsInterstitialOpen(false);
    }, [setIsInterstitialOpen]);

    useEffect(() => {
        setIsInterstitialOpen(Boolean(promoInterstitial?.length));
    }, [promoInterstitial]);

    return (
        <Overlay
            ContentComponent={InterstitialModalContent}
            isCentered={true}
            isOpen={isInterstitialOpen}
            onClose={onInterstitialClose}
            type={ModalTypes.INTERSTITIAL}
            disableCloseButton
        >
            <InterstitialContainer onClose={onInterstitialClose} />
        </Overlay>
    );
};

PromoInterstitialOverlay.propTypes = {
    currentView: PropTypes.string
};

export default withTheme(PromoInterstitialOverlay);
